import {
  AbstractControl,
  AsyncValidator,
  AsyncValidatorFn,
  FormGroup, NG_ASYNC_VALIDATORS,
  NG_VALIDATORS,
  ValidationErrors,
  Validator,
  ValidatorFn
} from '@angular/forms';
import {ConfigurationService} from '../services/configuration.service';
import {Directive, Input} from '@angular/core';
import {CustomerService} from '../services/customer.service';

@Directive({
    selector: '[parameterValue]',
    providers: [{ provide: NG_ASYNC_VALIDATORS, useExisting: ParameterValueValidatorDirective, multi: true }],
    standalone: false
})
export class ParameterValueValidatorDirective implements AsyncValidator {
  @Input("parameterKey") parameterKey: AbstractControl;
  @Input("snfCorpOid") snfCorpOid: number;
  @Input("snfAppUrl") snfAppUrl: string;
  @Input("customerId") customerId: number;
  @Input("configurationId") configurationId: string;
  @Input("triggerValidationOnDirty") triggerValidationOnDirty: boolean = true;

  constructor(
    private configurationService: ConfigurationService,
    private customerService: CustomerService
  ){

  }
  validate(control: AbstractControl): Promise<ValidationErrors> {
    return (parametervaluevalidator(this.parameterKey, this.snfCorpOid, this.snfAppUrl, this.configurationService, this.customerService,this.configurationId,this.customerId, this.triggerValidationOnDirty))(control);
  }
}
export function parametervaluevalidator(parameterKey: AbstractControl, snfCorpOid: number, snfAppUrl: string, configurationService: ConfigurationService, customerService: CustomerService, configurationId: string, customerId: number, triggerValidationOnDirty: boolean): any {
  return (control) => ParameterValueValidator.validate2(control,parameterKey, snfCorpOid, snfAppUrl, configurationService, customerService, configurationId, customerId, triggerValidationOnDirty );
}

export class ParameterValueValidator {

  public static async validate2(parameterValueCtrl: AbstractControl, parameterKeyCtrl: AbstractControl, snfCorpOid: number, snfAppUrl: string, configurationService: ConfigurationService, customerService: CustomerService, configurationId: string, customerId: number, triggerValidationOnDirty: boolean): Promise<ValidationErrors | any> {

    if (!parameterValueCtrl)
    return null;
    if (!parameterKeyCtrl)
      return null;

    // Validation passes
    parameterValueCtrl.setErrors(null);

    //this if handles if a specific row has been touched, we wanted to allow override in case hosting does not know the value to one of the blanks
    if(triggerValidationOnDirty){
      if(!parameterValueCtrl.dirty && !parameterKeyCtrl.dirty){
      return null;
    }}

// Get control references
    const emptySpacePattern = /\s/;
    const nonNumericPattern = /[^0-9]/;

    // If the key field contains "url" key word, the value can not have empty space(s) in the middle leading and pending spaces are ok.
    if ((parameterKeyCtrl.value.toLowerCase().includes('url') && parameterValueCtrl.value && emptySpacePattern.test(parameterValueCtrl.value.trim()))) {
      return {error: true, message: "Spaces are not allowed."}
    }

    // If the key field contains "url" key word, the value must start with http:// or https://
    if ((parameterKeyCtrl.value.toLowerCase().includes('app.url') ||
      parameterKeyCtrl.value.toLowerCase().includes('api.url') ||
      (parameterKeyCtrl.value.toLowerCase().includes('.url') && parameterKeyCtrl.value.toLowerCase().includes('thirdpartyintegration')) &&
      parameterValueCtrl.value)) {
      const parameterValue = parameterValueCtrl.value.trim().toLowerCase();
      const http = 'http://';
      const https = 'https://';

      if (!http.includes(parameterValue.substring(0, Math.min(parameterValue.length, http.length))) &&
        !https.includes(parameterValue.substring(0, Math.min(parameterValue.length, https.length)))) {
        return {error: true, message: "URL must start with http:// or https://."}
      }

      if (!parameterValue.startsWith(http) && !parameterValue.startsWith(https) && parameterValueCtrl.value) {
        parameterValueCtrl.setErrors({inCompleteScheme: true});
        return {error: true};
      }
    }

    //value blank validator
    if (!parameterValueCtrl.value?.trim() && !parameterKeyCtrl.value.toLowerCase().includes('thirdparty.tels.app.url.root')) {
      return {error: true, message: "Please enter a Value."}
    }

    if (parameterKeyCtrl.value?.toString().toLowerCase() === 'ca.feature.pin.clearmodeifxfailuresondeviceinyminutes') {
      const parameterValue = parameterValueCtrl.value.trim();

      if (!/^(?:0[1-9]|[1-9]\d?)_(?:0[1-9]|[1-9]\d?)$/.test(parameterValue)) {
        return {error: true, message: "Value must be in X_Y format where X and Y are numeric digits between 1 and 99."}
      }
    }

    // If the key field contains "corpoid" or "minute" key word, the value can only be numeric, leading and pending spaces are ok.
    if ((parameterKeyCtrl.value.toLowerCase().includes('corpoid') || parameterKeyCtrl.value.toLowerCase().includes('bp.walkaway.timeout.minutes') || parameterKeyCtrl.value.toLowerCase().includes('bp.idm.zones.limit')) && parameterValueCtrl.value && nonNumericPattern.test(parameterValueCtrl.value.trim())) {
      return {error: true, message: "Only numeric value is allowed."}
    }

    if (parameterKeyCtrl.value.toLowerCase().includes('globalsearch.enabled') && parameterValueCtrl.value.toLowerCase().includes('true') && (!snfAppUrl || !snfCorpOid)) {
      return {error: true, message: "Search requires SNF URL and corpOID parameters. Unable to activate Search."}
    }

    if (parameterKeyCtrl.value.toLowerCase() === 'bp.idm.crmid' && parameterValueCtrl.value && parameterValueCtrl.value !== parameterValueCtrl.value.toLowerCase()) {
      return {error: true, message: "CRM ID value must be lowercase."}
    }

    if (parameterKeyCtrl.value.toLowerCase() == 'bp.idm.zones.limit' && parameterValueCtrl.value != '') {
      let zoneLimitData = await configurationService.getConfigurationsZoneLimit(parameterValueCtrl.value).toPromise();
      if(zoneLimitData['bp.idm.zones.limit.exceeded']=='true'){
        return {error: true, message: "The available number for bp.idm.zones.limit is only up to " + (zoneLimitData['bp.idm.zones.limit.stack'] - zoneLimitData['bp.idm.zones.limit.total'] + " or less.")}
      }
    }

    if (parameterKeyCtrl.value.toLowerCase() == 'bp.user.provisioning.config.isdefault' && parameterValueCtrl.value == 'True') {
      if(customerId){
        let defaultCount = await customerService.getCustomerDefaultConfigCount(Number(customerId)).toPromise();
        if(Number(defaultCount)>=1){
          return {error: true, message: "There is already a default configuration set for this customer."}
        }
      } else{
        let customerIdByConfigId=await configurationService.getConfiguration(Number(configurationId)).toPromise();
        if(customerIdByConfigId.customerId){
          let defaultCount = await customerService.getCustomerDefaultConfigCount(Number(customerIdByConfigId.customerId)).toPromise();
          if(Number(defaultCount)>=1){
            return {error: true, message: "There is already a default configuration set for this customer."}
          }
        }

      }
    }
  }

/*  public static async validate(form: FormGroup, form2: FormGroup, configurationService: ConfigurationService): Promise<ValidationErrors | any> {
    if (!form) {
      return null;
    }

    // Get control references
    const parameterKeyCtrl = form.get('key');
    const parameterValueCtrl = form.get('value');
    const emptySpacePattern = /\s/;
    const nonNumericPattern = /[^0-9]/;
    const parameterSnfCorpOidCtrl = form2.get('corpOid');
    const parameterSnfAppUrlCtrl = form2.get('snfAppUrl');

    if (!parameterKeyCtrl || !parameterValueCtrl || !parameterKeyCtrl.value) {
      return null;
    }

    // If the key field contains "url" key word, the value can not have empty space(s) in the middle leading and pending spaces are ok.
    // tslint:disable-next-line:max-line-length
    if (parameterKeyCtrl.value.toLowerCase().includes('url') && parameterValueCtrl.value && emptySpacePattern.test(parameterValueCtrl.value.trim())) {
      parameterValueCtrl.setErrors({hasEmptySpace: true});
      return {hasEmptySpace: true};
    }

    // If the key field contains "url" key word, the value must start with http:// or https://
    // tslint:disable-next-line:max-line-length
    if ((parameterKeyCtrl.value.toLowerCase().includes('app.url') || parameterKeyCtrl.value.toLowerCase().includes('api.url')) && parameterValueCtrl.value) {
      const parameterValue = parameterValueCtrl.value.trim().toLowerCase();
      const http = 'http://';
      const https = 'https://';

      if (!http.includes(parameterValue.substring(0, Math.min(parameterValue.length, http.length))) &&
        !https.includes(parameterValue.substring(0, Math.min(parameterValue.length, https.length)))) {
        parameterValueCtrl.setErrors({incorrectScheme: true});
        return {incorrectScheme: true};
      }

      if (!parameterValue.startsWith(http) && !parameterValue.startsWith(https)) {
        parameterValueCtrl.setErrors({inCompleteScheme: true});
        return {inCompleteScheme: true};
      }
    }

    // If the key field contains "corpoid" or "minute" key word, the value can only be numeric, leading and pending spaces are ok.
    // tslint:disable-next-line:max-line-length
    if ((parameterKeyCtrl.value.toLowerCase().includes('corpoid') || parameterKeyCtrl.value.toLowerCase().includes('bp.walkaway.timeout.minutes') || parameterKeyCtrl.value.toLowerCase().includes('bp.idm.zones.limit')) && parameterValueCtrl.value && nonNumericPattern.test(parameterValueCtrl.value.trim())) {
      parameterValueCtrl.setErrors({hasNonNumeric: true});
      return {hasNonNumeric: true}
    }

    if (parameterKeyCtrl.value.toLowerCase().includes('globalsearch.enabled') && parameterValueCtrl.value.toLowerCase().includes('true') && (!parameterSnfAppUrlCtrl.value || !parameterSnfCorpOidCtrl.value)) {
      parameterValueCtrl.setErrors({gsDependency: true});
      return {gsDependency: true}
    }

    if (parameterKeyCtrl.value.toLowerCase().includes('bp.idm.zones.limit') && parameterValueCtrl.value != '') {
      let zoneData = await configurationService.getConfigurationsZoneLimit(parameterValueCtrl.value).toPromise();
      if(zoneData['bp.idm.zones.limit.exceeded']=='true'){
        parameterValueCtrl.setErrors({zonesLimitExceeded: true});
        return {zonesLimitExceeded: true}
      }
    }
    // Validation passes
    parameterValueCtrl.setErrors(null);
    return null;
  }*/
}
